export default __webpack_public_path__ + "static/media/PurchasingHistory.72c5eb3b.png";